module.exports = __webpack_public_path__ + "static/img/concept_page1.d499b12e.jpg";